const STOCK_STORAGE_KEY = 'lumenverde-stock';
const IN_TRANSIT_STORAGE_KEY = 'lumenverde-in-transit';
const ORDERS_STORAGE_KEY = 'lumenverde-orders';
const PROCUREMENT_STORAGE_KEY = 'lumenverde-procurements';
const STOCK_UPDATED_EVENT = 'lumenverde-stock-updated';

const canUseStorage =
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const readJSON = (key, fallback) => {
  if (!canUseStorage) return fallback;
  const raw = window.localStorage.getItem(key);
  if (!raw) return fallback;
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

const writeJSON = (key, value) => {
  if (!canUseStorage) return;
  window.localStorage.setItem(key, JSON.stringify(value));
};

const dispatchWindowEvent = (eventName, detail) => {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
  } catch {
    window.dispatchEvent(new Event(eventName));
  }
};

const getStockMap = () => {
  const stored = readJSON(STOCK_STORAGE_KEY, {});
  return stored && typeof stored === 'object' && !Array.isArray(stored) ? stored : {};
};

const saveStockMap = (nextStock) => {
  writeJSON(STOCK_STORAGE_KEY, nextStock);
  dispatchWindowEvent(STOCK_UPDATED_EVENT, nextStock);
};

const getInTransitMap = () => {
  const stored = readJSON(IN_TRANSIT_STORAGE_KEY, {});
  return stored && typeof stored === 'object' && !Array.isArray(stored) ? stored : {};
};

const saveInTransitMap = (nextInTransit) => {
  writeJSON(IN_TRANSIT_STORAGE_KEY, nextInTransit);
};

const getOrders = () => {
  const stored = readJSON(ORDERS_STORAGE_KEY, []);
  return Array.isArray(stored) ? stored : [];
};

const getProcurements = () => {
  const stored = readJSON(PROCUREMENT_STORAGE_KEY, []);
  return Array.isArray(stored) ? stored : [];
};

const saveProcurements = (nextProcurements) => {
  writeJSON(PROCUREMENT_STORAGE_KEY, nextProcurements);
};

export {
  getStockMap,
  saveStockMap,
  STOCK_UPDATED_EVENT,
  getInTransitMap,
  saveInTransitMap,
  getOrders,
  getProcurements,
  saveProcurements,
};
